<template>
<h1><font-awesome-icon icon="wind" /></h1>
<u>Wind</u>
<br>
<br>
Richtung: <b>{{direction}} °</b>
<p align="center"><AppCompass 
                      :degrees="(direction+180)%360" 
                      :wind_dirtext="wind_dirtext"
                  />
</p>
<br>
&#8960;:<b>{{speed}} m/s</b>
<br>
B&ouml;e:<b>{{gust}} m/s</b>
<br><br>
<svg v-if="beaufort !== null" class="bft" viewBox="0 0 208 40" width="208" height="40" xmlns="http://www.w3.org/2000/svg">
  <rect v-for="s in segments" :key="s.i" :x="4 + s.i * SEG_W" y="12" :width="SEG_W" height="12"
        :fill="s.color" :fill-opacity="s.i <= beaufort ? 1 : 0.25" stroke="#fff" stroke-opacity="0.6" stroke-width="0.5" />
  <g font-size="8" text-anchor="middle" fill="#fff">
    <text v-for="s in segments" :key="s.i" :x="4 + (s.i + 0.5) * SEG_W" y="36">{{ s.i % 2 === 0 ? s.i : '' }}</text>
  </g>
  <polygon v-if="gustX !== null" :points="`${gustX - 4},2 ${gustX + 4},2 ${gustX},11`" fill="#fff" stroke="#333" stroke-width="0.8" />
</svg>
<div v-if="beaufort !== null">{{beaufort}} Bft: {{beaufort_text}}</div>
</template>

<script>
import AppCompass from './compass.vue'

// Beaufort scale: [upper limit in m/s (exclusive), description]
const BEAUFORT = [
  [0.3, 'ruhig'],
  [1.6, 'leichte Luftbewegung'],
  [3.4, 'schwache Brise'],
  [5.5, 'sanfte Brise'],
  [8.0, 'mäßige Brise'],
  [10.8, 'frische Brise'],
  [13.9, 'starke Brise'],
  [17.2, 'steifer Wind'],
  [20.8, 'stürmischer Wind'],
  [24.5, 'Sturm'],
  [28.5, 'schwerer Sturm'],
  [32.7, 'orkanartiger Sturm'],
  [Infinity, 'Orkan']
]

const SEG_W = 200 / BEAUFORT.length
// green -> red for Bft 0..10, purple above
const COLORS = BEAUFORT.map((_, i) => i >= 11 ? '#7b3fb5' : `hsl(${120 - i * 12}, 70%, 45%)`)

// fractional Beaufort number (interpolated inside its band)
function beaufortPos(speed) {
  const i = BEAUFORT.findIndex(([limit]) => speed < limit)
  const upper = BEAUFORT[i][0]
  if (upper === Infinity) return i
  const lower = i === 0 ? 0 : BEAUFORT[i - 1][0]
  return i + (speed - lower) / (upper - lower)
}

export default {
  name: 'WindValues',
  props: {
    speed: Number,
    gust: Number,
    direction: Number,
    wind_dirtext: String
  },
  components: {
    AppCompass,
  },
  data() {
    return {
      SEG_W,
      segments: BEAUFORT.map((_, i) => ({ i, color: COLORS[i] }))
    }
  },
  computed: {
    // gust marker position on the Beaufort bar
    gustX() {
      if (!Number.isFinite(this.gust)) return null
      return 4 + beaufortPos(this.gust) * SEG_W
    },
    // index in BEAUFORT equals the Beaufort number
    beaufort() {
      if (!Number.isFinite(this.speed)) return null
      return BEAUFORT.findIndex(([limit]) => this.speed < limit)
    },
    beaufort_text() {
      return this.beaufort === null ? '' : BEAUFORT[this.beaufort][1]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
